export const loginUrl = "community/dashboardLogin";
export const getSurveyCountDistrictWiseForMap =
  "opendashboard/getSurveyCountDistrictWiseForMap";
export const getSurveyDetailsBasedOnCategory =
  "opendashboard/getSurveyDetailsBasedOnCategory";
export const getDistrictOptions = "opendashboard/getDistrictOptions";
export const getMonthWiseOnboardedUsersCount =
  "opendashboard/getMonthWiseOnboardedUsersCount";
export const getUsersCounters = "opendashboard/getUsersCounters";
export const surveyCountForOpenDashboard =
  "opendashboard/surveyCountForOpenDashboard";
export const surveyDependentCountForOpenDashboard =
  "opendashboard/surveyDependentCountForOpenDashboard";
export const getHealthFacilityOptions =
  "opendashboard/getHealthFacilityOptions";
export const getSurveyResponseCountsForDiagnosedUsers =
  "opendashboard/getSurveyResponseCountsForDiagnosedUsers";
export const surveyExcelGeneration =
  "caseSetSurvey/surveyExcelGeneration";
export const postClearCache = "caseSetSurvey/syncSurveyExcelGeneration";
export const getWhatsAppUsers = "/opendashboard/getWhatsAppUsers";
export const getRoleDetails = "roleAuth/getRoleDetails";
